import cn from 'classnames';

import { IConDefaultType } from '..';

export enum BookmarkIconVariant {
  ON = 'on',
  OFF = 'off',
}

export interface IBookmarkIconProps extends IConDefaultType {
  variant?: BookmarkIconVariant;
}

function BookmarkIcon({
  color,
  className,
  size = 38,
  rotate,
  flip,
  variant = BookmarkIconVariant.OFF,
}: IBookmarkIconProps) {
  return (
    <i
      className={cn('dds-icon', className, { flip })}
      style={{
        width: size,
        minWidth: size,
        height: size,
        transform: `rotate(${rotate}deg)`,
      }}
    >
      {variant === BookmarkIconVariant.OFF && (
        <svg viewBox="0 0 38 38" fill="none" xmlns="http://www.w3.org/2000/svg">
          <circle cx="19" cy="19" r="18.5" stroke="#E3E5E8" />
          <path
            d="M16 11H22C23.0609 11 24.0783 11.4216 24.8284 12.172C25.5786 12.9225 26 13.9403 26 15.0016V25.2056C25.9989 25.5068 25.9224 25.803 25.7773 26.067C25.6322 26.3309 25.4232 26.5543 25.1695 26.7165C24.9157 26.8788 24.6254 26.9747 24.325 26.9957C24.0246 27.0166 23.7237 26.9618 23.45 26.8362L19.83 25.1856C19.5694 25.0667 19.2864 25.0052 19 25.0052C18.7136 25.0052 18.4306 25.0667 18.17 25.1856L14.55 26.8362C14.2763 26.9618 13.9754 27.0166 13.675 26.9957C13.3746 26.9747 13.0843 26.8788 12.8305 26.7165C12.5768 26.5543 12.3678 26.3309 12.2227 26.067C12.0776 25.803 12.0011 25.5068 12 25.2056V15.0016C12 13.9403 12.4214 12.9225 13.1716 12.172C13.9217 11.4216 14.9391 11 16 11Z"
            fill="#D8D8D8"
          />
        </svg>
      )}
      {variant === BookmarkIconVariant.ON && (
        <svg width="38" height="38" viewBox="0 0 38 38" fill="none" xmlns="http://www.w3.org/2000/svg">
          <circle cx="19" cy="19" r="18.5" stroke="#00C3DD" />
          <path
            d="M12.4643 11.4651C13.402 10.527 14.6738 10 16 10H22C23.3262 10 24.598 10.527 25.5357 11.4651C26.4733 12.4031 27 13.6752 27 15.0016V25.2056L27 25.2091C26.9984 25.6776 26.8793 26.1381 26.6536 26.5487C26.4279 26.9592 26.1029 27.3066 25.7082 27.559C25.3135 27.8114 24.8618 27.9607 24.3944 27.9932C23.9274 28.0258 23.4597 27.9406 23.0341 27.7457L23.0332 27.7452L19.4151 26.0955C19.2849 26.036 19.1431 26.0052 19 26.0052C18.8569 26.0052 18.7154 26.0359 18.5851 26.0953L14.9668 27.7452L14.9659 27.7457C14.5403 27.9406 14.0726 28.0258 13.6056 27.9932C13.1382 27.9607 12.6865 27.8114 12.2918 27.559C11.8971 27.3066 11.5721 26.9592 11.3464 26.5487C11.1207 26.1381 11.0016 25.6776 11 25.2091L11 25.2056V15.0016C11 13.6752 11.5267 12.4031 12.4643 11.4651Z"
            fill="#00C3DD"
          />
        </svg>
      )}
    </i>
  );
}

export default BookmarkIcon;
